import { render, staticRenderFns } from "./BetslipB.vue?vue&type=template&id=1d40dfc4&scoped=true"
import script from "./BetslipB.vue?vue&type=script&lang=js"
export * from "./BetslipB.vue?vue&type=script&lang=js"
import style0 from "./BetslipB.vue?vue&type=style&index=0&id=1d40dfc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40dfc4",
  null
  
)

export default component.exports